export default {
  header: {
    create: 'Utwórz klucz API',
    update: 'Aktualizuj klucz API',
  },
  warning: {
    title: 'Klucz API jest widoczny tylko raz',
    subtitle: 'Nie możesz ponownie pobrać klucza API. Skopiuj go i zapisz w bezpiecznym miejscu',
  },
};
